import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router/auto'

const protectedRoutes = ['/dashboard', '/settings', '/profile']
function recursiveLayouts(route) {
  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i])
    
    return route
  }
  
  return setupLayouts([route])[0]
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash)
      return { el: to.hash, behavior: 'smooth', top: 60 }
    
    return { top: 0 }
  },
  extendRoutes: pages => [
    ...[...pages].map(route => recursiveLayouts(route)),
  ],
})

//added by abdullah 

// Global navigation guard to check for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = checkUserLoggedIn()

 
  // alert(isAuthenticated)

  // Check if user is going to the login page while logged in
  if (to.path === '/login' && isAuthenticated) {
    
    next({ path: '/' })
  }


  else if (protectedRoutes.includes(to.path) && !isAuthenticated) {
    next({ path: '/login' }) // Redirect to the login page if the route requires authentication
  } 
  else {
    next() // Proceed to the requested route
  }
})

// Example function to check if user is logged in
function checkUserLoggedIn() {
  
  return !!localStorage.getItem('token') 
}
export { router }
export default function (app) {
  app.use(router)
}
